import { Expose } from "class-transformer";
import { CmsResponseMetadata } from "../cms-response-metadata/cms-response-metadata.entity";
import { ICmsResponseWrapper } from "./cms-response-wrapper.entity.interface";

export class CmsResponseWrapper<T> implements ICmsResponseWrapper<T> {
  @Expose()
  data!: T;

  @Expose()
  meta?: CmsResponseMetadata;
}
